import { call, put } from 'redux-saga/effects';
import { NotificationsAPI } from '../apis';
import { NOTIFICATIONS_ACTION_TYPES } from '../actionTypes';

export function* getNotifications(action) {
  try {
    const response = yield call(NotificationsAPI.get, action.payload);
    const payload = response || {};

    if (payload) {
      yield put({
        type: NOTIFICATIONS_ACTION_TYPES.GET.SUCCESS,
        payload,
      });
    }
  } catch (error) {
    yield put({
      type: NOTIFICATIONS_ACTION_TYPES.GET.ERROR,
      error,
    });
  }
}

export function* deleteNotifications() {
  try {
    const response = yield call(NotificationsAPI.delete);

    const payload = response || {};

    if (payload) {
      yield put({
        type: NOTIFICATIONS_ACTION_TYPES.DELETE.SUCCESS,
        payload,
      });
    }
  } catch (error) {
    yield put({
      type: NOTIFICATIONS_ACTION_TYPES.DELETE.ERROR,
      error,
    });
  }
}


